module.exports = __webpack_public_path__ + "img/dashboards.8415cd60.png";